// extracted by mini-css-extract-plugin
export default {"xlsx":"DownloadButtonXlsx_xlsx__lLoDj"};